import axios from 'axios';
import { Golfer } from "../types/types"; 


export const adminLogin = async (email:any, code:any) => {
    
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/admin/login",
        data: {
            'email': email,
            'code': code
        },
        withCredentials: true
        
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}


export const accessOffers = async (lastName:any, memberNumber:any) => {
    
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/offers/login",
        data: {
            'lastName': lastName,
            'memberNumber': memberNumber
        },
        withCredentials: true
        
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}


export const getOfferRegions = async () => {

 const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/offers/filters",
        withCredentials: true
        
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })


};


export const getHsCompanies = async () => {
    
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/offers/companies",
        withCredentials: true
        
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}


export const resendOfferCode = async (lastName: string, memberNumber: string) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/offers/resend-code",
    { lastName, memberNumber }
  );
  return JSON.stringify(data);
};

export const verifyOfferOtp = async (lastName:any, memberNumber:any, code:any) => {
    
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/offers/login",
        data: {
            'lastName': lastName,
            'memberNumber': memberNumber,
            'offer_access_code': code
        },
        withCredentials: true
        
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
         
          
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}

export const getProducts = async (filter?: { property: string; value: string }) => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    url: process.env.REACT_APP_HOST_URL + "/api/vip/products",
    params: filter
  };

  return await axios.request(options)
    .then(function (response) {
      if (response.data) {
        // If data is already an array, stringify it
        // If data is an object with a nested array, unwrap it
        const data = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data.products)
            ? response.data.products
            : Array.isArray(response.data.data)
              ? response.data.data
              : [];

        return JSON.stringify(data);
      } else {
        console.log("getProducts: no data in response");
        return JSON.stringify([]);  // FIX: return empty array not undefined
      }
    })
    .catch(function (error) {
      console.error("getProducts error:", error);
      return JSON.stringify([]);  // FIX: return empty array not error object
    });
};

export const checkEmailExists = async (email: string) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/vip/check-email",
        data: {'email': email}
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}


export const checkActiveBronzeAddon = async (contactId: string) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/bronze-addon/active",
    { contactId }
  );
  return data as { success: boolean; active: { dealId: string; dealName: string; createDate: string } | null; membershipYear: string };
};

export const checkPendingReplacementCard = async (args: { lastName?: string; vipCardNumber?: string; ghinNumber?: string; contactId?: string }) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/replacement-card/pending",
    args
  );
  return data as { success: boolean; pending: { dealId: string; dealName: string; createDate: string } | null; message?: string };
};

export const SearchMembers = async (lastname: string, memberNumber: string) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/search",
        data: {'lastName': lastname, memberNumber: memberNumber}
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}


export const createMember = async (memberData: Golfer) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/create",
        data: {memberData}
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}

export const createOrUpdateMember = async (memberData: Golfer) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/member/upsert",
        data: {memberData}
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}


export const createGiftPurchase = async (memberData: Golfer) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/create_gift_order",
        data: {memberData}
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}

export const ApplyPromoCode = async (promoCode: string, cart_total: number, sku: number, package_total?: number) => {

    const response = await axios.request({
    method: "POST",
    url: `${process.env.REACT_APP_HOST_URL}/api/promo/apply`,
    headers: { "Content-Type": "application/json" },
    data: { promoCode, cart_total, sku, package_total },
  });

  return response.data;
}

export const UpdatePromoCode = async (promoCode: string, status:string) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
          },
        url: process.env.REACT_APP_HOST_URL+"/api/promo/unreserve",
        data: {"promoCode" : promoCode, "status": status}
    }
    return await axios.request(options)
      .then(function(response) {
        
        if (response.data)
        {
            return JSON.stringify(response.data);
        } else {
            console.log("NEW ERROR")
        }
      })
      .catch(function (error) {
          console.error(error);
          return JSON.stringify({error: error});
 
      })
}

export async function getCompanyOffers(companyId: string) {
  const { data } = await axios.get(process.env.REACT_APP_HOST_URL + `/api/offers/company/${companyId}`);
  return JSON.stringify(data);
}

export const getAllOffers = async (vipCardNumber?: string) => {
  const { data } = await axios.get(process.env.REACT_APP_HOST_URL + "/api/offers/all", {
    params: vipCardNumber ? { vipCardNumber } : undefined,
  });
  return JSON.stringify(data);
};



export async function redeemOffer(payload: {
  contactId: string;
  companyId: string;
  hubdbRowId: string;
  clubId: string;
  offerNumber: number;
  vipCardNumber: string;
  totalAllowed: number; // ✅ add if not there
  offerText?: string;
  groupId?: string | null;
}) {
  const { data } = await axios.post(
    process.env.REACT_APP_HOST_URL + `/api/offers/redeem`,
    payload
  );
 return JSON.stringify(data);
}



export const getOffersContact = async (contactId: string) => {
  const { data } = await axios.get(process.env.REACT_APP_HOST_URL + `/api/offers/contact/${contactId}`);
  return JSON.stringify(data);
};

export const getAdminHubSpotConfig = async () => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/hubspot-config"
  );
  return data as {
    success: boolean;
    portalId: string | null;
    refundedStage: string;
    partialRefundStage: string;
    redemptionReversedStage: string;
  };
};

export const getAdminDealStages = async () => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/deal-stages"
  );
  return data as { success: boolean; stages: Array<{ id: string; label: string }>; defaultStage: string };
};

export const getAdminTransactions = async (startDate?: string, endDate?: string, dealstage?: string) => {
  const params: Record<string, string> = {};
  if (startDate) {
    params.startDate = startDate;
    // Send local midnight as UTC ms so the server respects the user's calendar day
    params.startMs = String(new Date(`${startDate}T00:00:00`).getTime());
  }
  if (endDate) {
    params.endDate = endDate;
    params.endMs = String(new Date(`${endDate}T23:59:59.999`).getTime());
  }
  if (dealstage) params.dealstage = dealstage;
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/transactions",
    { params }
  );
  return data as {
    success: boolean;
    transactions: Array<{
      dealId: string;
      contactId: string;
      firstName: string;
      lastName: string;
      email: string;
      ghinNumber: string;
      vipCardNumber: string;
      transactionNumber: string;
      orderNumber: string;
      dealName: string;
      amount: string;
      amountRaw: number;
      vipPackage: string;
      dealstage: string;
      createDate: string;
      vipCardType: string;
      paymentMethod: string;
      checkNumber: string;
      isManual: boolean;
      ownerName: string;
      isBagTagOnly: boolean;
      hasBagTag: boolean;
      hasDonation: boolean;
      isReplacementCard: boolean;
      isWvVipCard: boolean;
      isBronzeAddon: boolean;
      usedGiftCard: boolean;
      ghinError: string;
      createdSource: string;
      netsuiteId: string;
      netsuiteCreditMemoId: string;
      packageChange: string;
      promoCode: string;
      promoAmount: number;
    }>;
    message?: string;
  };
};

export const getAdminDealGiftCard = async (dealId: string) => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + `/api/admin/deal-gift-card/${dealId}`
  );
  return data as {
    success: boolean;
    giftCard: {
      id: string;
      promoCode: string;
      value: string;
      valueRaw: number;
      status: string;
      type: string;
      createdAt: string;
    } | null;
    message?: string;
  };
};

export const getAdminBagTags = async (showMailed = false) => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/bag-tags",
    { params: { showMailed: showMailed ? "true" : "false" } }
  );
  return data as {
    success: boolean;
    bagTags: Array<{
      dealId: string;
      contactId: string;
      firstName: string;
      lastName: string;
      email: string;
      ghinNumber: string;
      vipCardNumber: string;
      bagTagName: string;
      vipPackage: string;
      dealstage: string;
      amount: string;
      amountRaw: number;
      address: string;
      address2: string;
      city: string;
      state: string;
      zip: string;
      createDate: string;
      isReplacement: boolean;
      shippedDate: string;
      mailedAt: string;
    }>;
    message?: string;
  };
};

export const shipBagTags = async (dealIds: string[]) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/bag-tags/ship",
    { dealIds }
  );
  return data as { success: boolean; message?: string };
};

export const unshipBagTags = async (dealIds: string[]) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/bag-tags/unship",
    { dealIds }
  );
  return data as { success: boolean; message?: string };
};

export const getAdminVipPackages = async () => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/vip-packages"
  );
  return data as {
    success: boolean;
    packages: Array<{
      dealId: string;
      contactId: string;
      firstName: string;
      lastName: string;
      email: string;
      ghinNumber: string;
      vipCardNumber: string;
      address: string;
      address2: string;
      city: string;
      state: string;
      zip: string;
      vipPackage: string;
      vipCardType: string;
      dealstage: string;
      amount: string;
      amountRaw: number;
      createDate: string;
      mailedDate: string;
      mailedAt: string;
      cardShipped: string;
      cardShippedDate: string;
    }>;
    message?: string;
  };
};

export const mailVipPackages = async (dealIds: string[]) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/vip-packages/mail",
    { dealIds }
  );
  return data as { success: boolean; message?: string };
};

export const unmailVipPackages = async (dealIds: string[]) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/vip-packages/unmail",
    { dealIds }
  );
  return data as { success: boolean; message?: string };
};

export const shipBagTagCard = async (dealId: string, shippedEpoch: number) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/bag-tags/ship-card",
    { dealId, shippedEpoch }
  );
  return data as { success: boolean; message?: string };
};

export const shipVipCard = async (dealId: string, shippedEpoch: number) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/vip-packages/ship",
    { dealId, shippedEpoch }
  );
  return data as { success: boolean; message?: string };
};

export const enrollContactInWorkflow = async (contactId: string) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/contacts/enroll-workflow",
    { contactId }
  );
  return data as { success: boolean; message?: string };
};

export const getAdminGiftCards = async (startDate?: string, endDate?: string) => {
  const params: Record<string, string> = {};
  if (startDate) {
    params.startDate = startDate;
    params.startMs = String(new Date(`${startDate}T00:00:00`).getTime());
  }
  if (endDate) {
    params.endDate = endDate;
    params.endMs = String(new Date(`${endDate}T23:59:59.999`).getTime());
  }
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/gift-cards",
    { params }
  );
  return data as {
    success: boolean;
    giftCards: Array<{
      id: string;
      contactId: string;
      orderId: string;
      firstName: string;
      lastName: string;
      email: string;
      promoCode: string;
      status: string;
      value: string;
      valueRaw: number;
      codeType: string;
      timesUsed: string;
      createDate: string;
      certificateUrl: string;
      transactionNumber: string;
      paymentMethod: string;
      checkNumber: string;
      miscNote: string;
      orderStage: string;
      canRefund: boolean;
    }>;
    message?: string;
  };
};

export const getAdminRefunds = async (startDate?: string, endDate?: string) => {
  const params: Record<string, string> = {};
  if (startDate) {
    params.startDate = startDate;
    params.startMs = String(new Date(`${startDate}T00:00:00`).getTime());
  }
  if (endDate) {
    params.endDate = endDate;
    params.endMs = String(new Date(`${endDate}T23:59:59.999`).getTime());
  }
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/refunds",
    { params }
  );
  return data as {
    success: boolean;
    refunds: Array<{
      dealId: string;
      contactId: string;
      firstName: string;
      lastName: string;
      email: string;
      ghinNumber: string;
      vipCardNumber: string;
      transactionNumber: string;
      orderNumber: string;
      dealName: string;
      amount: string;
      amountRaw: number;
      vipPackage: string;
      createDate: string;
    }>;
    message?: string;
  };
};

export const resendGiftCardEmail = async (orderId: string, email?: string, giftCardId?: string) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/gift-card/resend-email",
    { orderId, email, giftCardId }
  );
  return data as { success: boolean; message?: string };
};

export const refundGiftCard = async (payload: {
  giftCardId: string;
  orderId?: string;
  transactionId: string;
  amount: number;
}) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/gift-card/refund",
    payload
  );
  return data as { success: boolean; refundId?: string | null; message?: string; detail?: any };
};

export const processAdminRefund = async (payload: {
  transactionId: string;
  amount: number;
  dealId?: string;
  isPartialRefund?: boolean;
  paymentMethod?: string;
  lineItems?: { id: string; name: string; amount: number; quantity: number }[];
}) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/refund",
    payload
  );
  return data as { success: boolean; refundId?: string | null; message?: string; details?: any };
};

export const changeAdminPackage = async (payload: {
  dealId: string;
  currentDealAmount: number;
  oldLineItemId?: string;
  oldPackageName: string;
  oldPackagePrice: number;
  newProductId?: string;
  newPackageName: string;
  newPackageTabKey?: string;
  newPackagePrice: number;
  diff: number;
  paymentMethod?: string;
  transactionId?: string;
  versapayTransactionId?: string;
  versapayVpOrderNumber?: string;
  checkNumber?: string;
  miscNote?: string;
  addonDealId?: string;
  addonDealAmount?: number;
  addonPackageName?: string;
  addonPackagePrice?: number;
  addonTransactionId?: string;
  promoReversal?: { name: string; amount: number };
}) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/deal/change-package",
    payload
  );
  return data as { success: boolean; message?: string };
};

export const getAdminDealLineItems = async (dealId: string) => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + `/api/admin/deal/${dealId}/line-items`
  );
  return data as {
    success: boolean;
    lineItems?: { id: string; name: string; price: number; quantity: number; amount: number; dealId?: string }[];
    currentPackage?: string;
    linkedDeals?: { dealId: string; dealName: string; amount: number; transactionNumber: string; paymentMethod: string; netsuiteId?: string; role: "vip" | "addon" }[];
    message?: string;
  };
};

export const updateAdminDeal = async (dealId: string, properties: Record<string, string>) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/deal/update",
    { dealId, properties }
  );
  return data as { success: boolean; message?: string };
};

export const getAdminContact = async (contactId: string) => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + `/api/admin/contact/${contactId}`
  );
  return data as { success: boolean; contact?: any; message?: string };
};

export const getAdminContactDeals = async (contactId: string) => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + `/api/admin/contact/${contactId}/deals`
  );
  return data as { success: boolean; deals?: any[]; message?: string };
};

export const updateAdminContact = async (payload: {
  contactId: string;
  dealId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  date_of_birth?: string;
  sex?: string;
  address?: string;
  street_address_2?: string;
  city?: string;
  state?: string;
  zip?: string;
  vipCardType?: string;
  ghinNumber?: string;
  clearGhinError?: boolean;
}) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/contact/update",
    payload
  );
  return data as { success: boolean; message?: string };
};

export const lookupContactByGhin = async (ghinNumber: string, lastName: string) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/offers/lookup-by-ghin",
    { ghinNumber, lastName }
  );
  return JSON.stringify(data);
};


export type CreateVersapaySessionPayload = {
  amount: number;
  firstName?: string;
  lastName?: string;
  email?: string;
};

export type CreateVersapaySessionResponse = {
  success: boolean;
  sessionId: string;
  raw?: any;
};

export const createVersapaySession = async (
  payload: CreateVersapaySessionPayload
): Promise<CreateVersapaySessionResponse> => {
  const { data } = await axios.post((process.env.REACT_APP_HOST_URL || "") + "/api/versapay/session", payload, {
    params: { _t: Date.now() },
  });
  return data;
};

// Dashboard date range: Eastern dates YYYY-MM-DD; omitted means the last 30 days
export type DashboardRange = { from?: string; to?: string };

export const getAdminOrdersChart = async (range: DashboardRange = {}) => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/orders-chart",
    { params: range }
  );
  return data as {
    success: boolean;
    chartData: Array<{ date: string; label: string; count: number }>;
    packageCount: number;
    refundCount: number;
  };
};

export type AdminTopRedeemer = {
  contactId: string;
  firstName: string;
  lastName: string;
  email: string;
  vipCardNumber: string;
  count: number;
  lastRedeemedAt: string;
};

export const getAdminRedemptionsSummary = async (range: DashboardRange = {}) => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/redemptions-summary",
    { params: range }
  );
  return data as {
    success: boolean;
    chartData: Array<{ date: string; label: string; count: number }>;
    total: number;
    year: string;
    yearTotal: number;
    topRedeemers: AdminTopRedeemer[];
    updatedAt: string;
  };
};

export const getAdminOwners = async () => {
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/owners"
  );
  return data as {
    success: boolean;
    owners: Array<{ id: string; firstName: string; lastName: string; email: string }>;
  };
};

export type AdminRedemption = {
  id: string;
  contactId: string;
  firstName: string;
  lastName: string;
  email: string;
  offer: string;
  offerNumber: string;
  clubId: string;
  hubdbRowId: string;
  redeemedAt: string;
  vipCardNumber: string;
  exclusiveGroupId: string;
  pipelineStage: string;
  createDate: string;
};

export type AdminRedemptionSort = "lastRedeemed" | "firstName" | "lastName" | "email" | "vipCardNumber" | "count";

export type AdminRedemptionGolfer = {
  contactId: string;
  firstName: string;
  lastName: string;
  email: string;
  vipCardNumber: string;
  count: number;
  lastRedeemedAt: string;
  redemptions: AdminRedemption[];
};

// One page of golfers with their redemptions. year "" means the current season; "all" means every year.
// refresh reloads the server's copy of every redemption from HubSpot first.
export const getAdminRedemptions = async (opts: {
  page: number;
  pageSize: number;
  sort: AdminRedemptionSort;
  dir: "asc" | "desc";
  year?: string;
  q?: string;
  startDate?: string;
  endDate?: string;
  refresh?: boolean;
}) => {
  const params: Record<string, string> = {
    page: String(opts.page),
    pageSize: String(opts.pageSize),
    sort: opts.sort,
    dir: opts.dir,
  };
  if (opts.year) params.year = opts.year;
  if (opts.q) params.q = opts.q;
  if (opts.refresh) params.refresh = "1";
  if (opts.startDate) {
    params.startDate = opts.startDate;
    params.startMs = String(new Date(`${opts.startDate}T00:00:00`).getTime());
  }
  if (opts.endDate) {
    params.endDate = opts.endDate;
    params.endMs = String(new Date(`${opts.endDate}T23:59:59.999`).getTime());
  }
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/redemptions",
    { params }
  );
  return data as {
    success: boolean;
    contacts: AdminRedemptionGolfer[];
    totalContacts: number;
    totalRedemptions: number;
    page: number;
    pageSize: number;
    year: string;
    currentSeason: string;
    years: string[];
    updatedAt: string;
    message?: string;
  };
};

export type AccessCodeEmailStatus = "opened" | "delivered" | "sent" | "bounced" | "dropped" | "pending" | "not_found" | "unknown";

export type AccessCodeLog = {
  id: string;
  contactId: string;
  firstName: string;
  lastName: string;
  email: string;
  vipCardNumber: string;
  code: string;
  requestedAt: string;
  validUntil: string;
  codeStatus: "active" | "expired" | "replaced";
  emailStatus: AccessCodeEmailStatus;
  sentTo: string;
  emailsSent: number;
  emailSentAt: string;
  emailOpenedAt: string;
  source: string;
};

export type AccessCodeLogSort = "requestedAt" | "firstName" | "lastName" | "email";

// One page of offers access code requests with what happened to each code email.
// status "" = all, "active" = codes still valid, "problem" = email bounced, dropped or never sent.
export const getAccessCodeLogs = async (opts: {
  page: number;
  pageSize: number;
  sort: AccessCodeLogSort;
  dir: "asc" | "desc";
  status?: string;
  q?: string;
  refresh?: boolean;
}) => {
  const params: Record<string, string> = {
    page: String(opts.page),
    pageSize: String(opts.pageSize),
    sort: opts.sort,
    dir: opts.dir,
  };
  if (opts.status) params.status = opts.status;
  if (opts.q) params.q = opts.q;
  if (opts.refresh) params.refresh = "1";
  const { data } = await axios.get(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/access-code-logs",
    { params }
  );
  return data as {
    success: boolean;
    logs: AccessCodeLog[];
    total: number;
    golfers: number;
    activeCodes: number;
    emailProblems: number;
    emailEvents: boolean;
    page: number;
    pageSize: number;
    updatedAt: string;
    message?: string;
  };
};

export const reverseRedemption = async (redemptionId: string) => {
  const { data } = await axios.post(
    (process.env.REACT_APP_HOST_URL || "") + "/api/admin/redemptions/reverse",
    { redemptionId }
  );
  return data as { success: boolean; redemptionId?: string; message?: string };
};

// ── Audit log ──────────────────────────────────────────────────────────────
export type AuditChange = { field: string; oldValue: string; newValue: string };

export type AuditEntry = {
  id: string;
  timestamp: string;
  actor: string;
  action: string;
  label: string;
  details: string;
  changes?: AuditChange[];
};

export const getAuditLog = async (): Promise<AuditEntry[]> => {
  try {
    const { data } = await axios.get((process.env.REACT_APP_HOST_URL || "") + "/api/admin/audit-log");
    return data.entries || [];
  } catch {
    return [];
  }
};

export const logAuditEvent = async (payload: {
  actor?: string;
  action: string;
  label: string;
  details?: string;
  changes?: AuditChange[];
}): Promise<void> => {
  try {
    await axios.post((process.env.REACT_APP_HOST_URL || "") + "/api/admin/audit-log", payload);
  } catch {
    // Best-effort — never throw, auditing must not block the main flow
  }
};

export const confirmVersapayPayment = async (payload: {
  sessionId?: string;
  approvalResult: any;
  amount?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  address1?: string;
  city?: string;
  state?: string;
  zip?: string;
  vipCardNumber?: string; 
  lineItems?: Array<{
    type: string;
    number: string;
    description: string;
    price: number;
    quantity: number;
    discount: number;
  }>;
}) => {
  const { data } = await axios.post((process.env.REACT_APP_HOST_URL || "") + "/api/versapay/confirm", payload, {
    timeout: 35000,
  });
  return data;
};

// ── Upload History ─────────────────────────────────────────────────────────────

export interface UploadHistoryRow {
  name: string;
  email: string;
  package?: string;
  success: boolean;
  error?: string;
}

export interface UploadHistorySummary {
  id: string;
  uploadedAt: number;
  uploadedBy: string;
  filename: string;
  totalRows: number;
  successRows: number;
  failureRows: number;
}

export const saveUploadHistory = async (payload: {
  uploadedBy: string;
  filename: string;
  csvContent: string;
  results: UploadHistoryRow[];
}): Promise<void> => {
  await axios.post((process.env.REACT_APP_HOST_URL || "") + "/api/admin/upload-history", payload);
};

export const listUploadHistory = async (): Promise<UploadHistorySummary[]> => {
  const { data } = await axios.get((process.env.REACT_APP_HOST_URL || "") + "/api/admin/upload-history");
  return data.records as UploadHistorySummary[];
};

export const getUploadHistoryDetail = async (id: string): Promise<{ results: UploadHistoryRow[] } & UploadHistorySummary> => {
  const { data } = await axios.get((process.env.REACT_APP_HOST_URL || "") + `/api/admin/upload-history/${id}`);
  return data.record;
};

export const downloadUploadHistoryCsv = (id: string): void => {
  window.open((process.env.REACT_APP_HOST_URL || "") + `/api/admin/upload-history/${id}/csv`, "_blank");
};

// ── Annual Dates ───────────────────────────────────────────────────────────────

export interface AnnualDateEntry {
  year: number;
  startDate: string;     // "YYYY-MM-DD"
  endDate: string;       // "YYYY-MM-DD"
  renewalDays?: number;  // days before startDate current members can renew early (default 30)
}

export type SiteSettings = { giftTabVisible: boolean };

export const getSiteSettings = async (): Promise<SiteSettings> => {
  const { data } = await axios.get((process.env.REACT_APP_HOST_URL || "") + "/api/site-settings");
  return data.settings as SiteSettings;
};

export const setGiftTabVisible = async (visible: boolean, actor?: string): Promise<SiteSettings> => {
  const { data } = await axios.put((process.env.REACT_APP_HOST_URL || "") + "/api/admin/site-settings/gift-tab", { visible, actor });
  return data.settings as SiteSettings;
};

export type GiftCertificateTemplate = {
  source: "uploaded" | "default";
  fileName: string;
  size: number;
  updatedAt: string;
  updatedBy: string | null;
};

export const giftCertificateTemplateUrl = (preview = false) =>
  (process.env.REACT_APP_HOST_URL || "") + "/api/admin/gift-certificate-template/file" + (preview ? "?preview=1" : "");

export const getGiftCertificateTemplate = async (): Promise<GiftCertificateTemplate> => {
  const { data } = await axios.get((process.env.REACT_APP_HOST_URL || "") + "/api/admin/gift-certificate-template");
  return data.template as GiftCertificateTemplate;
};

export const uploadGiftCertificateTemplate = async (file: File, actor?: string): Promise<GiftCertificateTemplate> => {
  const { data } = await axios.put((process.env.REACT_APP_HOST_URL || "") + "/api/admin/gift-certificate-template", file, {
    headers: { "Content-Type": "application/pdf" },
    params: { fileName: file.name, actor },
  });
  return data.template as GiftCertificateTemplate;
};

export const getAnnualDates = async (): Promise<AnnualDateEntry[]> => {
  const { data } = await axios.get((process.env.REACT_APP_HOST_URL || "") + "/api/admin/annual-dates");
  return data.entries as AnnualDateEntry[];
};

// hubdb says whether the HubDB copy of the dates (read by HubSpot workflows) was updated too
export const saveAnnualDates = async (entries: AnnualDateEntry[], actor?: string) => {
  const { data } = await axios.post((process.env.REACT_APP_HOST_URL || "") + "/api/admin/annual-dates", { entries, actor });
  return data as { entries: AnnualDateEntry[]; hubdb?: { synced: boolean; message?: string } };
};